module.exports = __webpack_public_path__ + "media/src/assets/Images/CloseCross-5d98cfb8a8b6f9c186c2f5ccb0f489d8.svg";